namespace ui
{
	export namespace tab
	{
		export type NavBarStyles	= "tabs"|"pills"|"stacked";
		export interface NotifyInfo
		{
			type: "show"|"remove"|"hide"|"reload";
			entry: Entry;
		}

		export class Bar
			extends pattern.observer.Subject
		{
			private	m_ID: string;
			private m_Tab: Entry[];
			private m_Root: JQuery<HTMLElement>;
			private m_Stack: Entry[];
			private m_Style: NavBarStyles;
			private m_Control: TabControl;
			private m_Current?: Entry;
			private m_KeepLast: boolean;

			constructor( control: TabControl, style: NavBarStyles, idx: string, keepLast: boolean = false )
			{
				super();

				this.m_ID = idx + "_" + Math.ceil(Math.random() * 1000).toString().replace('.', '_');
				this.m_Tab = new Array<Entry>();
				this.m_Root = ui.$$.ul();
				this.m_Control = control;
				this.m_KeepLast = keepLast;

				this.m_Style = style;
				this.Style(style);

				this.m_Stack = [];
			}

			public Root(): JQuery<HTMLElement>
			{
				return this.m_Root;
			}

			public Build(): void
			{
				for ( const i in this.m_Tab )
				{
					this.m_Tab[i].Build();
				}
			}

			public notify( data: NotifyInfo ): void
			{
				if ( data.type == 'remove' )
				{
					if ( this.m_KeepLast && this.m_Tab.length <= 1 )
					{
						return;
					}

					let found = null;
					for ( const t in this.m_Tab )
					{
						this.m_Tab[t].update(data);

						if ( data.entry == this.m_Tab[ t ] )
						{
							this.unregister(this.m_Tab[t]);
							found = t;

							break;
						}
					}

					if (found) {
						this.m_Tab.splice(parseInt(found), 1);
					}

					for ( let i = 0; i < this.m_Stack.length; ++i )
					{
						if ( this.m_Stack[ i ] === data.entry )
						{
							this.m_Stack.splice(i, 1);
							--i;
						}
					}

					if ( this.m_Current == data.entry )
					{
						this.m_Current = this.m_Stack.pop();

						if ( this.m_Current )
						{
							this.notify({entry: this.m_Current, type: 'show'});
						}
					}
				}
				else
				{
					super.notify(data);

					if ( this.m_Current && this.m_Current != data.entry )
					{
						this.m_Stack.push(this.m_Current);
					}

					this.m_Current = data.entry;
				}
			}

			public Style( style?: NavBarStyles ): string|void
			{
				if ( style )
				{
					this.m_Style = style;

					this.m_Root.removeClass();
					this.m_Root.css('direction', 'initial');

					this.m_Root.addClass('nav');
					this.m_Root.addClass('nav-' + style);

					if ( this.m_Style == 'stacked' )
					{
						this.m_Root.css('direction', 'ltr');
					}

					return;
				}

				return this.m_Style;
			}

			public ID(): string
			{
				return this.m_ID;
			}

			public addTab(title: string, presenter: TabHTMLPresentation, close: boolean, reload: boolean): Entry
			{
				const entry = new Entry(title, this, presenter, close, reload);

				const li: JQuery<HTMLElement> = ui.$$.li();

				li.attr('role', 'presentation');

				this.m_Tab.push(entry);

				li.append(entry.Tab());

				this.m_Root.append(li);

				this.register(entry);

				return entry;
			}

			public getAllTabs(): Entry[]
			{
				return this.m_Tab;
			}

			public getTab(tabTitle: string): Entry | false {
				for (const i in this.m_Tab) {
					// if ( this.m_Tab[ i ].Key() == presenter.UUID )
					if (this.m_Tab[i].Title() === tabTitle) {
						this.notify({type: 'show', entry: this.m_Tab[i]});

						return this.m_Tab[i];
					}
				}

				return false;
			}

			public removeTab(tab: Entry | number): void {
				let element: Entry | null = null;
				for ( const j in this.m_Tab )
				{
					element = this.m_Tab[j];

					if ( typeof tab === 'number' )
					{
						if ( element.getIndex() == tab )
						{
							break;
						}
					}
					else if ( tab == element )
					{
						break;
					}
				}

				if ( element )
				{
					this.notify( { type: 'remove', entry: element } );
				}
			}
		}
	}
}
